/**
 * @description 页面路径与权限名称的匹配关系
 */
const pathNameAndPermissionName = [
  {
    path: '/layout/store-mapping',
    value: 'store_mapping'
  },
  {
    path: '/layout/service-goods',
    value: 'meituan_service'
  },
  {
    path: '/layout/staff-manage',
    value: 'technician_service'
  },
  {
    path: '/layout/store-business-setting',
    value: 'store_business'
  },
  {
    path: '/layout/reservation-data',
    value: 'meituan_reservation'
  },
  {
    path: '/layout/role-manage',
    value: 'role_permission'
  },
  {
    path: '/layout/account-manage',
    value: 'account_management'
  },
  {
    path: '/layout/store-inventory',
    value: 'non_beta_store_management'
  }
];

/**
 * @description 校验登录状态
 * @returns {boolean}
 */
function isLoginStatus() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const { token } = userInfo;
  return !!token;
}

/**
 * @description 判断当前登录者是否来自总部
 * @returns {boolean}
 */
function isUserHeadQuarter() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const { kdtName = '' } = userInfo;
  return kdtName === '总部';
}

/**
 * @description 校验路由页面的btn是否操作编辑权限
 */
function checkUserHasBtnPermission(pathname) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const { permissions = [] } = userInfo;
  const hasEditPermission = permissions
      .filter(permission => permission.includes(':edit'))
      .map(permission => permission.split(':')[0]);

  const routes = pathNameAndPermissionName
      .filter(o => hasEditPermission.includes(o.value))
      .map(o => o.path);

  return routes.includes(pathname);
}


function getPermission() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const { permissions = [] } = userInfo;
  return permissions;
}


export default {
  isLoginStatus,
  isUserHeadQuarter,
  checkUserHasBtnPermission,
  pathNameAndPermissionName,
  getPermission,
};
